module.exports = __webpack_public_path__ + "static/media/Telefono.d10f060c.svg";